import { render, staticRenderFns } from "./FieldNoteEditorDialog.vue?vue&type=template&id=5357164a&scoped=true"
import script from "./FieldNoteEditorDialog.vue?vue&type=script&lang=js"
export * from "./FieldNoteEditorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5357164a",
  null
  
)

export default component.exports